module.exports = __webpack_public_path__ + "img/gurkopashova.d6a3e1a3.jpg";